.primary-text-container {
    display: flex;
    text-align: right;
    color: var(--grey-dk);
    font-size: var(--font-normal);
    margin-bottom: 2px;
    gap: 8px;
    width: fit-content;
    align-self: flex-end;
}

.secondary-text {
    color: var(--grey-lt);
    font-size: var(--font-small);
    text-align: right;
    width: fit-content;
    align-self: flex-end;
}
